module.exports = __webpack_public_path__ + "img/logo2.ab56727f.png";